import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'capitalizeFirstWord',
    standalone: false
})

export class CapitalizeFirstWordPipe implements PipeTransform {
    transform(value: string): string {
        if (!value) {
            return '';
        }
        
        //this simple version assumes the input is a single sentence.
        return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    }
}
